import { graphql } from 'gql';

export const uerPriceListRatioForIncludingToContractChangeCodeFilterGql = graphql(`
    query uerPriceListRatioForIncludingToContractChangeCodeFilter(
        $contractChangeId: Long!
        $ratioCode: String!
        $where: FilterValueOfStringFilterInput
    ) {
        uerPriceListRatioForIncludingToContractChangeCodeFilter(
            contractChangeId: $contractChangeId
            ratioCode: $ratioCode
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const uerPriceListRatioForIncludingToContractChangeNameFilterGql = graphql(`
    query uerPriceListRatioForIncludingToContractChangeNameFilter(
        $contractChangeId: Long!
        $ratioCode: String!
        $where: FilterValueOfStringFilterInput
    ) {
        uerPriceListRatioForIncludingToContractChangeNameFilter(
            contractChangeId: $contractChangeId
            ratioCode: $ratioCode
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const uerPriceListRatioForIncludingToContractChangeStatusFilterGql = graphql(`
    query uerPriceListRatioForIncludingToContractChangeStatusFilter(
        $contractChangeId: Long!
        $ratioCode: String!
        $where: FilterValueOfRatioRecordStatusEnumFilterInput
    ) {
        uerPriceListRatioForIncludingToContractChangeStatusFilter(
            contractChangeId: $contractChangeId
            ratioCode: $ratioCode
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);
